import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { BaseHttpService } from '../../services/common/base.http.service';
import { LoggedInUserService } from '../../services/common/logged-in-user.service';
import { PagedResult } from '../../shared/models/pagedResult.model';
import { SearchParameters } from '../../shared/models/searchParameters.model';
import { administrationConst } from '../administration.const';
import { ResultInfo } from '../../shared/models/result-info.model';
import { BankAccountChangesModel } from '../models/bank-account-changes.model';
import { SearchBankAccountModel } from '../models/search-bank-accounts-changes.model';

@Injectable({
  providedIn: 'root'
})
export class EmployeeBankAccountService {
  baseHttpService = inject(BaseHttpService);
  loggedInUserService = inject(LoggedInUserService);
  userEmail: string;
  
  searchBankAccounts(data: SearchParameters<EmployeeBankAccountModel>): Observable<PagedResult<EmployeeBankAccountModel[]>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.post<PagedResult<EmployeeBankAccountModel[]>>(administrationConst.bankAccounts, data, { headers: headers });
  }

  searchBankAccount(employeeNo: number): Observable<EmployeeBankAccountModel> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });    
    return this.baseHttpService.get<EmployeeBankAccountModel>(administrationConst.bankAccount + "/" + employeeNo);
  }

  addBankAccount(data: ManageEmployeeBankAccountModel): Observable<ResultInfo>{    
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.post(administrationConst.bankAccount, data, { headers: headers });
  }

  updateBankAccount(data: ManageEmployeeBankAccountModel): Observable<ResultInfo>{    
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.put(administrationConst.bankAccount, data, { headers: headers });
  }

  deleteBankAccount(data: ManageEmployeeBankAccountModel): Observable<ResultInfo>{    
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.post(administrationConst.deleteBankAccount, data, { headers: headers });
  }

  searchBankAccountChanges(searchParameters: SearchParameters<SearchBankAccountModel>): Observable<PagedResult<BankAccountChangesModel[]>> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    return this.baseHttpService.post<PagedResult<BankAccountChangesModel[]>>(administrationConst.bankAccountChanges, searchParameters, { headers: headers });
  } 
}